import { render, staticRenderFns } from "./ReviewsBlock.vue?vue&type=template&id=fc988fec&"
import script from "./ReviewsBlock.vue?vue&type=script&lang=js&"
export * from "./ReviewsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports